import { Modal, Col, Row, Space, Typography, Dropdown, message } from "antd";
import { useState } from "react";
import { Guid } from "guid-typescript";
import WellbeingMaterialCategoriesView from "../components/wellbeing-corner/WellbeingMaterialCategoriesView";
import WellbeingMaterialCategoriesFormDialog from "../components/wellbeing-corner/WellbeingMaterialCategoriesFormDialog";
import { SearchQuery } from "../code/search-query/search-query";
import { getWellbeingMaterialCategoriesExport } from "../repository/data.repository";
import Loader from "../controls/Loader";
import { WellbeingMaterialCategory } from "../repository/data.default";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";
import { getProblemMessage } from "../utils/http";

function WellbeingMaterialCategoriesPage() {
  const [modal, contextHolder] = Modal.useModal();
  const [searchQuery, setSearchQuery] = useState<SearchQuery>({
    conditions: [],
  });
  const [inputMode, setInputMode] = useState<"add" | "update" | "delete">(
    "add",
  );
  const [inputOpen, setInputOpen] = useState(false);
  const [inputValues, setInputValues] = useState<WellbeingMaterialCategory>(
    {} as any,
  );
  const [triggerView, setTriggerView] = useState(Guid.create().toString());
  const permissions = useSelector(authorizeSelectors.permissions);

  function onSearch(searchQuery: SearchQuery): void {
    setSearchQuery(searchQuery);
  }

  function onInputOpen(
    mode: "add" | "update" | "delete",
    values?: WellbeingMaterialCategory,
  ): void {
    setInputMode(mode);
    setInputOpen(true);
    setInputValues(values || ({} as any));
  }

  function onInputFinish(): void {
    setInputOpen(false);
    setTriggerView(Guid.create().toString());
  }

  function onInputClose(): void {
    setInputOpen(false);
  }

  function onDownloadExport(): void {
    const loading = modal.info({
      content: (
        <Typography.Text className="m-1 ml-2 inline-block">
          Downloading material-categories export file..
        </Typography.Text>
      ),
      footer: null,
      centered: true,
      icon: <Loader />,
    });
    getWellbeingMaterialCategoriesExport({
      searchQuery,
      pageNumber: 0,
      pageSize: Number.MAX_SAFE_INTEGER,
    })
      .then(() => loading.destroy())
      .catch((err) => {
        loading.destroy();
        message.error(getProblemMessage(err) || "Failed to download export.");
      });
  }

  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      <Row className="sticky top-0 z-10 flex flex-row flex-wrap items-center p-4">
        <Typography.Title className="m-0 flex-auto" level={4}>
          Material Categories
        </Typography.Title>
        <Space className="flex flex-row">
          <Dropdown.Button
            type="primary"
            disabled={!permissions.can("WellbeingCornerCategories", "create")}

            className={`${!permissions.can("WellbeingCornerCategories", "create") ? "disabled" : ""}`}
            menu={{
              items: [
                {
                  key: "downloadExport",
                  label: "Export to Excel",
                  disabled: !permissions.can("WellbeingCornerCategories", "view"),
                  onClick: onDownloadExport,
                },
              ],
            }}
            onClick={() => onInputOpen("add")}
          >
            Add Category
          </Dropdown.Button>
        </Space>
      </Row>
      <Col className="flex flex-auto flex-col overflow-hidden p-4 pb-4 pt-0">
        <WellbeingMaterialCategoriesView
          trigger={triggerView}
          onAction={(key: string, record: any) =>
            onInputOpen(key as any, record)
          }
          onSearch={onSearch}
        />
      </Col>
      <WellbeingMaterialCategoriesFormDialog
        mode={inputMode}
        open={inputOpen}
        initialValues={inputValues}
        onFinish={onInputFinish}
        onCancel={onInputClose}
      />
      {contextHolder}
    </Col>
  );
}

export default WellbeingMaterialCategoriesPage;
